import { render, staticRenderFns } from "./PivotGrid.vue?vue&type=template&id=6d9c7662&"
import script from "./PivotGrid.vue?vue&type=script&lang=js&"
export * from "./PivotGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Pipelines\\release\\07.00\\maintenance\\Fontes\\corp\\produto\\wes\\WebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d9c7662')) {
      api.createRecord('6d9c7662', component.options)
    } else {
      api.reload('6d9c7662', component.options)
    }
    module.hot.accept("./PivotGrid.vue?vue&type=template&id=6d9c7662&", function () {
      api.rerender('6d9c7662', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "content/components/Orcamento/Consultar/PivotGrid.vue"
export default component.exports